"use client";

import type { ReactElement } from "react";
import { SharedPageError } from "@/components";

function RootError(): ReactElement {
  return <SharedPageError />;
}

export default RootError;
